import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import { AIPStructure } from "@wlocalhost/ngx-email-builder";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "tail-structure",
  templateUrl: "structure.component.html",
  styleUrls: ["structure.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StructureComponent
  extends AIPStructure
  implements OnInit, AfterViewInit
{
  @ViewChild("textButton", { static: false })
  textButton!: ElementRef<HTMLButtonElement>;
  toaster = inject(ToastrService);
  activeBlockId : string | null = null;

  ngAfterViewInit() {
    if (this.shouldTriggerClickByDefault()) {
      this.triggerClick();
    }
  }

  shouldTriggerClickByDefault(): boolean {
    return true;
  }
  triggerClick() {
    if (this.textButton) {
      this.textButton.nativeElement.click();
    }
  }
  edited(ins: any) {
    console.log("Edited called for", ins);
    ins.edit();
  }
  override ngOnInit() {}
  edited1(ins: any) {
    ins.edit();
  }
  paste(event: Event, ins: any) {
     event.preventDefault();
    navigator.clipboard
      .readText()
      .then((text) => {
        if (ins.type === "html") {
          const htmlContent = `<b>{{${text}}}</b>`;
          ins.innerHTML += htmlContent;
        } else if (ins.type === "button") {
          ins.innerText = `{{${text}}}`;
        } else {
          const htmlContent = `{{${text}}}`;
          ins.innerText += htmlContent;
        }
        ins.edit();
        // navigator.clipboard.writeText(''); // clear the clipboard
      })
      .catch((err) => {
        console.error("Paste failed:", err);
        this.toaster.error(
          "Unable to read clipboard! Make sure you allow clipboard permissions."
        );
      });
  }
  toggleBlockMenu(ins: any) {
  this.activeBlockId = this.activeBlockId === ins.id ? null : ins.id;
}
}
